<template>
  <div class="admin-workflow-history-activity-comment">
    {{ items.displayName }} <strong>نوشت :</strong>
    <div class="comment">{{ items.comment }}</div>
  </div>
</template>

<script>
export default {
  name: 'admin-workflow-history-activity-comment',
  props: {
    items: {
      type: Object,
      default: null,
    },
  },
}
</script>

<style scoped lang='scss'>
.admin-workflow-history-activity-comment {
  strong {
    color: #556be6;
  }
  .comment {
    margin-top: 15px;
    background: #fafafa;
    border-radius: 5px;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 25px;
    color: #74788d;
    padding: 6px;
  }
}
</style>